import { Button, Grid, TextField } from '@material-ui/core';
import React, { ChangeEvent } from 'react';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { publicaColors } from '~/src/dash/utils/colors';

interface IState {
  isEdited: boolean;
}

interface ICustomStyleProp {
  [key: string]: any;
}

interface IProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  error?: { Name: string };
  disabled?: boolean;
  disableAllUppercase?: boolean;
  class?: string;
  iconSizeLarge?: boolean;
  iconSizeSmall?: boolean;
  customStyle?: ICustomStyleProp;
}

export class ModernTextField extends React.Component<IProps, IState> {
  // State Initialization
  state: IState = {
    isEdited: false,
  };

  // Initialization
  constructor(props: IProps) {
    super(props);
  }

  handleLostFocus = () => {
    this.setState({ isEdited: false });
  };

  handleStartEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    this.setState({ isEdited: true });
  };

  // Render
  render() {
    let errorName;
    if (this.props.error !== undefined) {
      errorName = this.props.error.Name;
    }
    // When edited
    if (this.state.isEdited) {
      return (
        <TextField
          className='pb-modern-text-field_textfield'
          name='Name'
          fullWidth
          autoFocus
          value={this.props.value}
          onChange={this.props.onChange}
          error={!!errorName}
          helperText={errorName}
          onBlur={this.handleLostFocus}
          disabled={this.props.disabled}
          style={{
            wordBreak: 'break-word',
            ...this.props.customStyle,
          }}
        />
      );
    } else {
      return (
        <Button
          className='pb-modern-text-field_button'
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => this.handleStartEdit(e)}
          disabled={this.props.disabled}
          style={{
            justifyContent: 'flex-start',
            wordBreak: 'break-word',
            width: '100%',
            height: '36px',
            textTransform: this.props.disableAllUppercase ? 'none' : 'uppercase',
            ...this.props.customStyle,
          }}
        >
          {/* styling to remove scrollbar in app.css */}
          <Grid
            item
            className='pb-modern-text-button-grid'
            style={{
              textOverflow: 'clip',
              overflow: 'scroll',
              whiteSpace: 'nowrap',
            }}
          >
            {this.props.value}
          </Grid>
          &nbsp;&nbsp;&nbsp;&nbsp;
          {!this.props.disabled && (
            <IconV2
              name={'edit'}
              color={publicaColors.gray}
              large={!!this.props.iconSizeLarge ? this.props.iconSizeLarge : false}
              small={!!this.props.iconSizeSmall ? this.props.iconSizeSmall : false}
            />
          )}
        </Button>
      );
    }
  }
}
